var exports = {
  "k": "xa15a2ab7--289316--container",
  "j": "xa15a2ab7--289316--photo",
};

module.exports = exports;
